<script setup>
  const { path } = defineProps(['path']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <div class="flag">
    <VideoLoop class="flag"><source :src="path" type="video/mp4" /></VideoLoop>
  </div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .flag {
    position: relative;
    width: 133.33vw;

    min-width: px(700);
    // max-width: px(1200);
    margin-bottom: -14vw;
    video {
      width: 100%;
    }

    img {
      position: absolute;
      width: 100%;
    }

    @include break-small {
      width: 280vw;
      margin-bottom: -28vw;
    }
  }
</style>
